// @flow
import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';
import { DateTimePicker } from 'react-widgets';

import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

import { colors } from '../../../shared/styles';

momentLocalizer(moment);

type DatePickerProps = {
    disabled: boolean,
    input: any,
    label: string,
    data: any,
    meta: any,
    min?: any,
    max?: any,
    defaultValue?: any,
};

const StyledDatePicker = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .rw-datetimepicker {
        width: 100%;
        height: 31px;
        box-sizing: border-box;
        border: solid 1px;
        border-radius: 4px;
        font-size: 14px;
        margin: 0;
        appearance: menulist;

        &,
        &:hover {
            background-color: ${colors.white};
            border-color: ${colors.offWhite};
        }

        &.rw-open {
            &,
            > .rw-input {
                border-radius: 4px 4px 0 0;
            }
        }
    }

    & .rw-datetimepicker > .rw-input,
    & .rw-filter-input > .rw-input {
        height: 29px;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 14px;
        line-height: 17px;
    }

    &.input-error {
        & .rw-datetimepicker {
            border-color: ${colors.error.default};
        }

        span.error {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }
`;

const DatePicker = (props: DatePickerProps) => {
    const {
        disabled,
        input: { value },
        input,
        label,
        meta: { touched, error },
    } = props;

    const id = shortid.generate();
    const wrapperCls = touched && error ? 'input-error' : '';

    return (
        <StyledDatePicker className={wrapperCls}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <DateTimePicker
                id={id}
                onChange={input.onChange}
                disabled={disabled}
                time={false}
                value={!value ? null : new Date(value)}
                format={'DD/MM/YYYY'}
            />
            {touched &&
                error &&
                <span className="error">
                    {error}
                </span>}
        </StyledDatePicker>
    );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/shared/forms/DatePicker.js